/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connect a new private LLM endpoint to your organization." |
*
* @param {Private_Models_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_add_description = /** @type {((inputs?: Private_Models_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie einen neuen privaten LLM-Endpunkt mit Ihrer Organisation.")
	return /** @type {LocalizedString} */ ("Connect a new private LLM endpoint to your organization.")
});